var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M8.805 12.615a4.62 4.62 0 0 1-3.282-1.365c-1.82-1.82-1.82-4.745 0-6.532a4.62 4.62 0 0 1 3.282-1.365c1.235 0 2.405.487 3.283 1.365.26.26.26.682 0 .975-.26.26-.683.26-.975 0a3.22 3.22 0 0 0-2.308-.943c-.877 0-1.69.325-2.307.943a3.276 3.276 0 0 0 0 4.615c.617.617 1.43.942 2.307.942s1.69-.325 2.308-.942c.26-.26.682-.26.975 0 .26.26.26.682 0 .975a4.65 4.65 0 0 1-3.283 1.332m0 3.315C4.418 15.93.875 12.355.875 8S4.418.07 8.805.07c4.355 0 7.93 3.543 7.93 7.93 0 4.388-3.575 7.93-7.93 7.93m0-14.495A6.57 6.57 0 0 0 2.24 8a6.547 6.547 0 0 0 6.565 6.565A6.57 6.57 0 0 0 15.37 8a6.547 6.547 0 0 0-6.565-6.565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyRight);
export default __webpack_public_path__ + "static/media/copyRight.beccff11eef5c753283831b83a4c6aa5.svg";
export { ForwardRef as ReactComponent };